module.exports = __webpack_public_path__ + "static/media/vodafone-logo-small.f4faf5f4.svg";